import React, {useState, useEffect} from "react";
import {Modal, ModalBody, ModalHeader, ModalFooter} from "reactstrap";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import Loader from "../../components/Loader";
import ZeusButton from "../../components/Button";
import SelectCreator from "../Forms/components/SelectCreator";
import {requestUserList} from "../../redux/Actions/group.action";
import {handoffSnapshot} from "../../redux/Actions/tsdb.actions";
import {getUsersList} from "../../redux/Selectors/group.selector";

const SnapshotHandoff = (props) => {
  const {open, onCancel, selectedSnapshot, updateCallback} = props;
  const [users, setUsers] = useState([]);
  const dispatch = useDispatch();
  const user_list = useSelector(getUsersList);

  useEffect(() => {
    dispatch(requestUserList(true));
  }, [dispatch]);

  const handleSubmit = () => {
    const callback = () => {
      onCancel();
      updateCallback();
    };
    dispatch(handoffSnapshot({dashboard_id: selectedSnapshot, users}, callback));
  };

  return (
    <>
      <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"md"}>
        <Loader />
        <ModalHeader>Snapshot Handoff</ModalHeader>
        <ModalBody>
          <div className="ml--3 mr--3">
            <SelectCreator
              label={"USER"}
              options={user_list}
              value={users}
              onChange={(e) => setUsers(e.target.value)}
              classNamePrefix={"select_user"}
              id={"select_user"}
              large
              isMulti
            />
            <ModalFooter>
              <ZeusButton data-cy="submit-btn" onClick={handleSubmit}>
                SUBMIT
              </ZeusButton>
              <ZeusButton
                onClick={onCancel}
                data-cy={"cancel-btn"}
                className="info-small"
              >
                CANCEL
              </ZeusButton>
            </ModalFooter>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

SnapshotHandoff.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  selectedSnapshot: PropTypes.number,
  updateCallback: PropTypes.func,
};
export default SnapshotHandoff;
